<template>
  <UserAvatar :text="firstNameLetter" :background-color :size aria-label="User Avatar">
    <img v-if="imageUrl" :src="imageUrl" alt="Profile Image" />
  </UserAvatar>
</template>

<script>
import UserAvatar from "./UserAvatar.vue";

export default {
  components: { UserAvatar },
  props: {
    user: { type: Object, required: true },
    size: {
      type: String,
      default: "medium",
      validator: (value) => ["small", "medium", "big"].includes(value),
    },
  },
  computed: {
    imageUrl() {
      return this.user.imageUrl;
    },
    firstNameLetter() {
      const letter = this.user.name || this.user.email || "?";
      return letter.substring(0, 1).toUpperCase();
    },
    backgroundColor() {
      return this.user.color || "#2d2124";
    },
  },
};
</script>
